
import qs from 'qs'
import {Toast, Dialog} from 'vant'

export default {
  inject: ['reload'],
  name: 'taskProgress.vue',
  data() {
    return {
      dataList: [],
      timer: 0,
    }
  },
  mounted() {
    this.getProgressData()
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.getProgressData()
    }, 3000)
  },
  methods: {
    getProgressData() {
      this.$ajax('/etv/selectPageEqTaskProgress.json').then(res => {
        let arr = res.data.data.psersonList
        // 1：下载成功；2：等待下载；其他：下载中
        arr.forEach(res => {
          if (res.state == 1) {
            res.stateCh = this.$t('append_field.download_success')
            res.strColor = 'strGreen'
          } else if (res.state == 2) {
            res.stateCh = this.$t('append_field.waiting_download')
            res.strColor = 'strGray'
          } else {
            res.stateCh = this.$t('append_field.downloading')
            res.strColor = 'strGray'
          }
        })
        this.dataList = arr
      })
    },
    deleteBtn(r1, r2) {
      let postData = {
        type: r2,
      }
      let msg = ''
      if (r2 == 'deleteSingle') {
        postData.id = r1.id
        msg = this.$t('append_field.confirm_delete')
      } else if (r2 == 'deleteAll') {
        msg = this.$t('append_field.confirm_delete_all')
      } else if (r2 == 'deleteFinish') {
        msg = this.$t('append_field.confirm_delete_selected')
      }

      if (this.dataList.length == 0) {
        Toast(this.$t('append_field.no_data_to_clear'))
        return
      }
      Dialog.confirm({
        title: this.$t('append_field.delete')
        , message: msg,
      }).then(() => {
        this.$ajax.post('/etv/deleteEqTaskProgressById.json', qs.stringify(postData)).then(res => {
          if(res.data.code===0){
            Toast(res.data.msg)
            this.getProgressData()
          }else {
            Toast(res.data.msg)
          }


        })
      })
    },
    refresh() {
      this.dataList = []
      this.getProgressData()
    }
  },
}
